export const DEV_SUMMARY_FIELD_KEY = 'devSummary';
